Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.GraphicsPathCommand = module.exports.default = {
	CUBIC_CURVE_TO: 6,
	CURVE_TO: 3,
	LINE_TO: 2,
	MOVE_TO: 1,
	NO_OP: 0,
	WIDE_LINE_TO: 5,
	WIDE_MOVE_TO: 4
};